import paymentService from "../../services/paymentService";
import Vue from "vue";
import {distinctById} from "../../utils";

const state = {
    payment_loading: true,
    payments: [],
    next_page: 1,
};

const actions = {
    editPayment({commit}, payment) {
        return new Promise((resolve, reject) => {
            paymentService.editPayment(payment)
                .then(payment => {
                    commit('addPayment', payment)
                    resolve();
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось изменить информацию платежа.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    },
    addPayment({commit}, payment) {
        let fd = new FormData();
        for (let key in payment) {
            fd.append(key, payment[key]);
        }
        return new Promise((resolve, reject) => {
            paymentService.postPayment(fd)
                .then(payment => {
                    commit('addPayment', payment)
                    resolve();
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось добавить платеж.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    },
    getPayments({commit, state}, params) {
        if (!state.next_page) {
            return
        }
        state.payment_loading = state.next_page === 1;
        params.page = state.next_page;
        return new Promise((resolve, reject) => {
            paymentService.fetchPayments(params)
                .then(response => {
                    let payments = distinctById(state.payments.concat(response.results));
                    commit('setPayments', {next: response.next, payments});
                    state.payment_loading = false;
                    resolve();
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию о платежах.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    state.payment_loading = false;
                    reject();
                })
        })
    },
    getPayment(store, params) {
        return new Promise((resolve, reject) => {
            paymentService.getPayment(params)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию о платеже.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    },
    getCountPayment(store, params) {
        return new Promise((resolve, reject) => {
            paymentService.getCountPayment(params)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию о платеже.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    }
};

const mutations = {
    addPayment(state, payment) {

        let balance = payment.client_info.balance

        // Обновляем все балансы в списке
        state.payments.forEach(obj => {
            if (obj.client === payment.client) {
                obj.client_info.balance = balance;
            }
        })

        const index = state.payments.findIndex(obj => obj.id === payment.id);
        if (index !== -1) {
            Vue.set(state.payments, index, payment);
        } else {
            state.payments.unshift(payment);
        }
    },
    setPayments(state, {next, payments}) {
        if (next) {
            state.next_page += 1;
        } else {
            state.next_page = null;
        }
        state.payments = payments;
    },
    clearData(state) {
        state.next_page = 1;
        state.payments = [];
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
}